export default "__VITE_ASSET__p$8ml4gm__"